import { render } from "./mision.vue?vue&type=template&id=430640c7&scoped=true"
import script from "./mision.vue?vue&type=script&lang=js"
export * from "./mision.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-430640c7"

export default script